export default __webpack_public_path__ + "static/forrest-aerial-shot-1d4f65f19ed9b5afbcec3b7e0623e3c1.jpeg";